const EMAIL_PATTERN = /^[A-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?$/i;

export default function isValidEmail(email) {
  if (typeof email !== 'string' || email.length > 254) {
    return false;
  }

  const [localPart] = email.split('@');
  return localPart.length <= 64 && EMAIL_PATTERN.test(email);
}
